// extracted by mini-css-extract-plugin
export default {"title":"OrganizationWidget_title__yuTY7","detailsWrapper":"OrganizationWidget_detailsWrapper__KaWCw"};